<template>
  <v-card
    dark
    class="pa-2"
    width="100%"
    color="rgba(0,0,0,0.3)"
    style="border: 1px solid #757575"
  >
    <h5 class="text-center mb-1">発表中の警報・注意報</h5>
    <v-row no-gutters align="center">
      <template v-if="alerts.length > 0">
        <v-chip
          v-for="alert in alerts"
          :key="alert"
          :color="getAlertColor(alert)"
          :text-color="getAlertColor(alert) === 'warning' ? 'black' : null"
          small
          class="mr-1 mb-1"
        >
          {{ alert }}
        </v-chip>
      </template>
      <template v-else>
        <div class="text-center" style="width: 100%">
          なし
        </div>
      </template>
    </v-row>
  </v-card>
</template>
<script>
import axios from "axios";

const ALERT_URL = "https://data.riskma.net/bosai/alert/status";
const ALERT_POINT = "JPTK";
const ALERT_CITIES = ["1320100"];

export default {
  name: "AlertStatus",
  data() {
    return {
      alerts: []
    };
  },
  computed: {
    baseDate() {
      return this.$store.getters.baseDate;
    }
  },
  async mounted() {
    await this.fetchAlerts();
  },
  watch: {
    async baseDate(newVal, oldVal) {
      if (!newVal.isSame(oldVal)) {
        await this.fetchAlerts();
      }
    }
  },
  methods: {
    async fetchAlerts() {
      const params = {
        point: ALERT_POINT,
        city: ALERT_CITIES.join(","),
        date: this.baseDate.format("YYYY/MM/DD HH:mm")
      };
      const response = await axios
        .create({
          responseType: "json"
        })
        .get(ALERT_URL, { params });
      if (response === null) {
        this.alerts = [];
        return;
      }
      const targets = [];
      if (response && response.data && response.data) {
        const pointStatus = response.data.find(s => s.id === ALERT_POINT);
        if (pointStatus && pointStatus.cities) {
          pointStatus.cities.forEach(row => {
            row.alerts.forEach(alert => {
              if (!targets.includes(alert)) {
                targets.push(alert);
              }
            });
          });
        }
      }
      this.alerts = targets;
    },
    getAlertColor(alertName) {
      if (alertName.includes("特別警報")) {
        return "black";
      } else if (alertName.includes("危険警報")) {
        return "purple";
      } else if (alertName.includes("警報")) {
        return "red";
      } else if (alertName.includes("注意報")) {
        return "warning";
      } else {
        return "gray";
      }
    }
  }
};
</script>
